import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as User from '../../helpers/User';
import * as Common from '../../helpers/Common';
import {validateFile} from '../../helpers/Fields';
import * as Config from '../../config/Config';
const $=window.$;


export default class NoticeBoard extends Component {

	 constructor(props) {


        super(props);

        this.state={
            noticeboard:[],
            count : 0,
            noticecount : 0,
        };

    }

    

    
    getNoticeBoard(){
        Common.reactLoader("show", "Please wait...");
        let learnerID = Common.getUserData("id", true);
         let productID = Common.getUserData("productID", true);
         let fullName = Common.getUserData("fullName", true);
         let corpID = Common.getUserData("corporateID", true);
         let pinID = Common.getUserData("pinID", true);
        // let productID = 209;
        // let pinID = 149;
        // let corpID = 11;
        fetch(Config.domainUrl+'left/notice-board', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID,lr_product:productID,fullName:fullName,corpID:corpID,pinID:pinID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
                Common.reactLoader("hide");
                //alert(JSON.stringify(responseJson));
                this.setState({

                    noticeboard : responseJson.noticeboards,
                    noticecount : responseJson.noticecount,

                });


         });
    }

	

	componentDidMount() {
	
        this.getNoticeBoard();

	}

  render() {
    let corporateID = Common.getUserData('corporateID', true);
    let noticeboards = null;
    const {Webview} = this.props;
    if(this.state.noticeboard!=undefined || this.state.noticeboard!=null){
    	noticeboards = this.state.noticeboard.map((notices,keys)=>{
            return(
                     <span key={`noticed_${keys}`} dangerouslySetInnerHTML={{__html: notices}}/>
                )
        });
    }

    return (
            <aside className="slide-out slide1">
                {(Webview===undefined && Webview!=='webview' && corporateID!=77) && <a className="handle" href="javascript:void(0);" id='noticeboard' >Notice Board</a>}
                <h2><img src={'images/img1.jpg'} align="texttop" alt="" border="0"/> Notice Board</h2>
                <div style={{height:'400px',overflow: 'hidden !important', float: 'left', width: '100%', overflowY: 'scroll'}}>{noticeboards}</div>
               {(Webview===undefined && Webview!=='webview' && corporateID!=77) &&  (this.state.noticecount>0)?<span className="badge-noticeboard" data-badge={this.state.noticecount}></span>:''}
            </aside>
    );
  }
}



// WEBPACK FOOTER //
// ./src/partials/qlink_partials/NoticeBoard.js